import healthreport from './health/healthreport'
export default {
    health: {
        healthreport: healthreport,
    },
}


// WEBPACK FOOTER //
// ./src/api/tmh/index.js